import jQuery from 'jquery';
import React from 'react';
import CheckboxList from './ui/CheckboxList.jsx';
import Dropdown from './ui/Dropdown.jsx';
import Image from './ui/features/Image.jsx';
import Button from './ui/button/Button.jsx';
import Configurator from './Configurator.jsx';
import baseConfStyles from './Configurator.styl';
import styles from './EnclosureAccessoryConfigurator.styl';

/**
 * Конфигуратор аксессуаров для шкафов
 */
class EnclosureAccessoryConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			specList: {},
			enclosureArticleSearch: false
		};

		this.onListItemCheck          = this.onListItemCheck.bind(this);
		this.onBtnSpecSaveClick       = this.onBtnSpecSaveClick.bind(this);
		this.onSwitchConfigurator     = this.onSwitchConfigurator.bind(this);
		this.onBtnExcelClick          = this.onBtnExcelClick.bind(this);
		this.onSpecListChange         = this.onSpecListChange.bind(this);
		this.onEnclosureArticleSearch = this.onEnclosureArticleSearch.bind(this);
		this.onEnclosureArticleSearchBlur = this.onEnclosureArticleSearchBlur.bind(this);
	}

	getType() {
		return 'enclosure_accessory';
	}

	getCustomStyles() {
		return styles;
	}

	applyFilters() {
		let accessories = super.applyFilters('accessory');

		accessories = accessories.filter(accessory => {
			const enc2acc = this.db.list.enclosure2accessory[this.enclosure.article];
			return (Array.isArray(enc2acc) && enc2acc.indexOf(accessory.article) >= 0);
		});

		return accessories;
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;

				if (this.props.enclosure) {
					this.enclosure = this.getEnclosureByArticle(this.props.enclosure);
				} else {
					this.enclosure = this.db.list.enclosure[0];
				}

				this.filter['type'] = this.db.filter.type[0];

				const items = this.applyFilters();
				const articles = items.map(item => {
					return item.article;
				});

				this.setState({
					articles
				});
			}
		);
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			enclosure: `[${this.enclosure.article}] ${this.enclosure.name}`,
			speclist: JSON.stringify(this.state.specList)
		};

		super.doPrint(_params);
	}

	getEnclosureByArticle(article) {

		for (let i = 0; i < this.db.list.enclosure.length; i++)
		{
			if (this.db.list.enclosure[i].article === article) {
				return this.db.list.enclosure[i];
			}
		}

		return null;
	}

	onEnclosureChange(article) {

		this.enclosure = this.getEnclosureByArticle(article);

		const items = this.applyFilters();

		const articles = items.map(item => {
			return item.article;
		});

		this.setState({
			enclosureArticleSearch: false,
			specList: {},
			item: null,
			articles
		});
	}

	onListItemCheck(value) {
		if (this.state.item && (value === this.state.item.article)) {
			return;
		}
		if(this.getType()==='enclosure_accessory'){
			jQuery.getJSON(
				'itkcfg.php',
				{
					type: this.getType(),
					action: 'getItemNSI',
					article: value
				},
				itemInfo => {
					this.setState({itemInfo});
				}
			)
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItem',
				article: value
			},
			item => {
				this.setState({item});
			}
		);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onBtnSpecSaveClick() {
		this.setState(prevState => {
			let specList = prevState.specList;

			if (specList[this.state.item.article])
			{
				specList[this.state.item.article].count++;
			}
			else
			{
				specList[this.state.item.article] = {
					count: 1,
					name: this.state.item.name,
					article: this.state.item.article
				};
			}
			return specList;
		},()=>{
			 this.preDoAddToCart()
		});
	}

	preDoAddToCart(){
		let specList=[]
		specList.push(this.enclosure)
		for(let i in this.state.specList){
			specList.push(this.state.specList[i])
		}
		this.doAddToCart(specList)
	}
	onDwgDownload(item) {
		if (!item || !item.dwg) {
			return;
		}

		window.location = `itkcfg.php?type=${this.getType()}&action=getDwg&article=${item.article}`;
	}

	onStepDownload() {
		window.location = 'http://www.iek.ru/products/standard_solutions/download/mednye-i-opticheskie-komponenty-sks-i-bloki-pdu-v-step.rar';
	}

	onFilterChange(prop, value) {
		if (prop === 'type')
		{
			this.filter = {};

			this.db.filter.type.every(typeId_value => {
				const [, typeName] = typeId_value.split('_');

				if (typeName === value) {
					value = typeId_value;
					return false;
				}

				return true;
			});
		}

		super.onFilterChange(prop, value);
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator();
		}
	}

	onSpecListChange(article, count) {
		this.setState(prevState => {
			const specList = prevState.specList;
			const countInt = parseInt(count);

			if (countInt <= 0) {
				delete specList[article];
			} else {
				specList[article].count = isNaN(countInt) ? 1 : countInt;
			}

			return specList;
		},()=>{
			this.preDoAddToCart()
		});
	}

	onEnclosureArticleSearch(event) {
		const article = event.target.value.toUpperCase();
		if (!article)
		{
			this.setState({
				enclosureArticleSearch: article
			});

			return;
		}

		const enclosure = this.getEnclosureByArticle(article);

		if (enclosure)
		{
			this.onEnclosureChange(article);
		}
		else
		{
			this.setState({
				enclosureArticleSearch: article
			});
		}
	}

	onEnclosureArticleSearchChange() {
	}

	onEnclosureArticleSearchBlur() {
		if (this.state.enclosureArticleSearch !== false) {
			this.setState({
				enclosureArticleSearch: false
			});
		}
	}

	buildDropdownFilters() {
		const stateFilters = this.db.filter;

		let dynamicFilters = [];

		let dropDownTop = 255;

		Object.keys(this.db.filter).forEach(filterPropName => {
			if (filterPropName === 'type') {
				return;
			}

			const [typeId, itemPropName] = filterPropName.split('_');

			const [filterTypeId] = this.filter.type.split('_');

			if (typeId !== filterTypeId) {
				return;
			}

			let filterItems = ['Все'];

			stateFilters[filterPropName].forEach((filterItemValue) => {

				const prevFilterValue = this.filter[itemPropName];

				if (prevFilterValue) {
					// Какие варианты, если бы фильтр не был применен
					delete this.filter[itemPropName];
				}

				const itemList = this.applyFilters();

				const articles = itemList.map(item => {
					return item.article;
				});

				for (let itemIndex in itemList) {
					const item = itemList[itemIndex];

					if (articles.indexOf(item.article) < 0) {
						continue;
					}

					if (item[itemPropName] === filterItemValue) {
						filterItems.push(filterItemValue);
						break;
					}
				}

				if (prevFilterValue) {
					this.filter[itemPropName] = prevFilterValue;
				}

			});

			dynamicFilters.push(
				<Dropdown
					key={filterPropName}
					items={filterItems}
					onItemChange={value => this.onFilterChange(itemPropName, value)}
					className={styles.accessoryTypeList}
					style={{top: dropDownTop + 'px'}}
					selectStyle={{width: '238px'}}
					label={`${itemPropName}:`}
				/>
			);

			dropDownTop += 52;
		});

		return dynamicFilters;
	}


	render() {
		if (!this.db) {
			return <div className={styles.cfg}></div>;
		}

		const canPrint = Object.keys(this.state.specList).length > 0;

		const typeFilterItems = this.db.filter.type.map(type => {
			const [, typeName] = type.split('_');
			return typeName;
		});


		return (
			<div className={styles.cfg}>

				{/* Заголовок конфигуратора */}
				<span className={styles.title}>Конфигуратор аксессуаров и PDU для шкафов</span>

				{/* Поиск шкафа по артикулу */}
				<input
					className={styles.enclosureArticle}
					type="text"
					value={this.state.enclosureArticleSearch !== false ? this.state.enclosureArticleSearch : this.enclosure.article}
					onInput={this.onEnclosureArticleSearch}
					onChange={this.onEnclosureArticleSearchChange}
					onBlur={this.onEnclosureArticleSearchBlur}
					style={{backgroundColor: this.state.enclosureArticleSearch === false ? null : '#f88'}}
				/>

				{/* Выбрать шкаф из списка */}
				<select className={styles.enclosureList} value={this.enclosure.article} onChange={e => this.onEnclosureChange(e.target.value)} title={this.enclosure.name}>
					{this.db.list.enclosure.map(enclosure => {
						return <option value={enclosure.article} key={enclosure.article}>{enclosure.name}</option>;
					})}
				</select>

				{/* Перейти к подбору шкафов по параметрам */}
				<Button
					buttonStyle={styles.btnSwitchToEnclosureConf}
					iconStyle={styles.btnSwitchToEnclosureConfIcon}
					textStyle={styles.btnSwitchToEnclosureConfText}
					text="Перейти к подбору шкафов по параметрам"
					onClick={this.onSwitchConfigurator}
				/>

				{/* Тип аксессуара */}
				<Dropdown
					label="Тип аксессуара:"
					className={styles.accessoryTypeList}
					items={typeFilterItems}
					onItemChange={value => this.onFilterChange('type', value)}
					style={{top: '203px'}}
					selectStyle={{width: '238px'}}
				/>

				{/* Динамические фильтры */}
				{this.buildDropdownFilters()}

				{/* Список артикулов аксессуаров */}
				<CheckboxList
					className={styles.accessoryList}
					items={this.state.articles}
					onItemCheck={this.onListItemCheck}
					selectedValue={this.state.item ? this.state.item.article : null}
				/>

				{/* Сохранить в спецификацию */}
				<Button
					buttonStyle={styles.btnSaveSpec}
					buttonDisabledStyle={styles.btnSaveSpecDisabled}
					iconStyle={styles.btnSaveSpecIcon}
					textStyle={styles.btnSaveSpecText}
					text="Сохранить в спецификацию"
					disabled={!this.state.item}
					onClick={this.onBtnSpecSaveClick}
				/>

				{/* Список спецификации */}
				<SpecList
					ref="specList"
					items={this.state.specList}
					onChange={this.onSpecListChange}
					enclosure={this.enclosure.article}
				/>

				{/* Артикул и название */}
				<div className={styles.itemInfoBG}/>
				{this.state.item ? (
						<a href={`https://qr.iek.group/${this.state.item.article}`}
							 target="_blank">
							<div className={styles.itemInfo}>
								<div className={styles.itemInfo_Article}>{this.state.item.article}</div>
								<div>{this.state.item.name}</div>
							</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Описание */}
				{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description ? (
				<div className={styles.description}>{this.state.itemInfo[0].Description[0].desc_ru}</div>
				) : (
				<div className={styles.descriptionEmpty}/>
				)}

				{/* Изображение */}
				<Image
					className={styles.itemImg}
					url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgJpeg && this.state.itemInfo[0].ImgJpeg[0].file_ref.uri ? this.state.itemInfo[0].ImgJpeg[0].file_ref.uri : null}
				/>
				{/* Сохранить в PDF */}
				<Button
					buttonStyle={styles.btnPdf}
					buttonDisabledStyle={styles.btnPdfDisabled}
					iconStyle={baseConfStyles.btnPdfIcon}
					text="Сохранить в PDF"
					disabled={!canPrint}
					onClick={this.onBtnPrintPdfClick}
				/>

				{/* Скачать в EXCEL */}
				 <Button
					 buttonStyle={styles.btnExcel}
					 buttonDisabledStyle={styles.btnExcelDisabled}
					 iconStyle={styles.btnExcelIcon}
					 text="Скачать в EXCEL"
					 disabled={!canPrint}
					 onClick={this.onBtnExcelClick}
				 />

				{/* Распечатать */}
				<Button
					buttonStyle={styles.btnPrint}
					buttonDisabledStyle={styles.btnPrintDisabled}
					iconStyle={baseConfStyles.btnPrintIcon}
					text="Распечатать"
					disabled={!canPrint}
					onClick={this.onBtnPrintClick}
				/>

				{/* Скачать чертеж dwg */}
				<Button
					buttonStyle={styles.btnDwgDownload}
					buttonDisabledStyle={styles.btnDwgDownloadDisabled}
					iconStyle={styles.btnDwgDownloadIcon}
					text="Скачать чертеж dwg"
					disabled={!this.state.item || !this.state.item.dwg}
					onClick={() => this.onDwgDownload(this.state.item)}
				/>

				{/* Скачать 3D-модели STEP */}
				<Button
					buttonStyle={styles.btnStepDownload}
					iconStyle={styles.btnDwgDownloadIcon}
					text="Скачать 3D-модели STEP"
					onClick={this.onStepDownload}
				/>
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '710px'}}/>
				<a className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#76d750',
					width: '50%',
					height: '22px',
					top: '710px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '714px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-24</span>
			</div>
		);
	}
}

/**
 * Список спецификации (наименование - кол-во)
 */
class SpecList extends React.Component
{
	render() {
		const rows = Object.keys(this.props.items).map((article, itemIndex) => {

			const itemCount = this.props.items[article].count;

			const rowClassName = (itemIndex % 2 === 0 ? `${styles.specListTableRow} ${styles.specListTableRow_even}` : styles.specListTableRow);

			return (
				<tr key={article} className={rowClassName}>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellArticle}`}>{article}</td>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellCount}`}>
						<input type="text" value={itemCount} className={styles.specListCountInput}
									 onChange={e => this.props.onChange(article, e.target.value)} />
						<span className={styles.specListDelete} title="Удалить позицию"
									onClick={() => this.props.onChange(article, 0)} />
					</td>
				</tr>
			);

		});

		return (
			<div className={styles.specList}>
				<table className={styles.specListTable}>
					<colgroup>
						<col style={{width: '172px'}}/>
						<col style={{width: '124px'}}/>
					</colgroup>
					<tbody>

						<tr className={styles.specListTableRow}>
							<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellArticle}`}>{this.props.enclosure}</td>
							<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellCount}`}>1</td>
						</tr>

						{rows}

					</tbody>
				</table>
			</div>
		);
	}
}

export default EnclosureAccessoryConfigurator;



// WEBPACK FOOTER //
// ./src/react/EnclosureAccessoryConfigurator.jsx